function updatePartnersSliderWidth() {
  const animationSlider = document.querySelectorAll(".carousel__wrapper:not(.no-slider)");
  if (!animationSlider) return;

  const sliderSpeed = 60;

  animationSlider.forEach((slider) => {
    const width = slider.scrollWidth + 20;
    slider.style.width = `${width}px`;

    const duration = width / sliderSpeed;

    slider.style.animationDuration = `${duration}s`;
  });
}

window.addEventListener("resize", () => {
  setTimeout(() => {
    updatePartnersSliderWidth();
  }, 300);
});

updatePartnersSliderWidth();
